import { InjectionToken } from '@angular/core';
import { ContentShellConfig } from '../shared/models/content-shell-config.model';

export const contentShellConfig = new InjectionToken<ContentShellConfig>('contentShellConfig');
